import { FC } from "react";

import { clsxMerge } from "shared/lib/helpers";
import { MetricItemI } from "./interfaces";

export const MetricItem: FC<MetricItemI> = ({
  className,
  value,
  label,
  valueClassName,
  labelClassName,
}) => (
  <div className={clsxMerge("", className)}>
    <span className={clsxMerge("mb-2 typography-header-1", valueClassName)}>
      {value}
    </span>

    <p className={clsxMerge("max-w-[260px] typography-body-2", labelClassName)}>
      {label}
    </p>
  </div>
);
